import { useCallback, useEffect, useRef } from "react"
import { motion, useMotionTemplate, useMotionValue } from "motion/react"
import { cn } from "../../lib/utils"

export function MagicCard({ children, className, contentClassName, gradientSize = 220, gradientColor = "#e4f3df", gradientOpacity = 0.82, gradientFrom = "#69a65c", gradientTo = "#d6b85f" }) {
  const mouseX = useMotionValue(-gradientSize)
  const mouseY = useMotionValue(-gradientSize)
  const sizeRef = useRef(gradientSize)
  useEffect(() => { sizeRef.current = gradientSize }, [gradientSize])
  const reset = useCallback(() => {
    mouseX.set(-sizeRef.current)
    mouseY.set(-sizeRef.current)
  }, [mouseX, mouseY])
  const move = useCallback((event) => {
    const rect = event.currentTarget.getBoundingClientRect()
    mouseX.set(event.clientX - rect.left)
    mouseY.set(event.clientY - rect.top)
  }, [mouseX, mouseY])

  return (
    <motion.div
      className={cn("group relative isolate overflow-hidden rounded-[inherit] border border-transparent", className)}
      onPointerMove={move}
      onPointerLeave={reset}
      style={{ background: useMotionTemplate`linear-gradient(var(--color-background) 0 0) padding-box, radial-gradient(${gradientSize}px circle at ${mouseX}px ${mouseY}px, ${gradientFrom}, ${gradientTo}, var(--color-border) 100%) border-box` }}
    >
      <div className="absolute inset-px z-20 rounded-[inherit] bg-white" />
      <motion.div className="pointer-events-none absolute inset-px z-30 rounded-[inherit] opacity-0 transition-opacity duration-300 group-hover:opacity-[var(--gradient-opacity)]" style={{ background: useMotionTemplate`radial-gradient(${gradientSize}px circle at ${mouseX}px ${mouseY}px, ${gradientColor}, transparent 100%)`, "--gradient-opacity": gradientOpacity }} />
      <div className={cn("relative z-40", contentClassName)}>{children}</div>
    </motion.div>
  )
}
